<template>
  <v-app id="inspire" class="login-page">
    <v-main>
      <div class="login-shell">
        <header class="login-header">
          <a class="login-brand" href="https://www.youkeya.cn/" target="_blank" rel="noopener noreferrer" aria-label="有课丫官网（新窗口打开）"><img src="../assets/login-brand.svg" alt="有课丫" width="148" height="40"><span>机构管理平台</span></a>
          <a class="website-link" href="https://www.youkeya.cn/" target="_blank" rel="noopener noreferrer">了解有课丫<v-icon size="16">mdi-arrow-top-right</v-icon></a>
        </header>

        <div class="login-stage">
          <section class="login-story" aria-labelledby="login-story-title">
            <div class="story-copy">
              <p class="story-eyebrow"><span></span>为认真做教育的你</p>
              <h1 id="login-story-title">把每一节课，<br>安排得井井有条。</h1>
              <p class="story-description">从第一次报名，到每一次成长。<br>让机构的日常管理，更轻松一点。</p>
            </div>
            <login-schedule-illustration class="story-illustration" />
            <div class="story-capabilities" aria-label="产品功能"><span><v-icon size="17">mdi-account-multiple-outline</v-icon>学员管理</span><span><v-icon size="17">mdi-calendar-check-outline</v-icon>排课消课</span><span><v-icon size="17">mdi-message-outline</v-icon>家校服务</span></div>
          </section>

          <section class="login-form-panel" aria-labelledby="login-heading">
            <div class="login-form-inner">
              <div class="form-heading"><h2 id="login-heading">欢迎回来</h2><p>登录有课丫，开启有序的一天。</p></div>
              <v-btn-toggle v-model="loginType" mandatory class="login-methods" aria-label="选择登录方式">
                <v-btn :value="0" :aria-pressed="loginType === 0" :ripple="false"><v-icon size="18">mdi-cellphone</v-icon>手机号登录</v-btn>
                <v-btn :value="1" :aria-pressed="loginType === 1" :ripple="false"><v-icon size="18">mdi-account-outline</v-icon>员工号登录</v-btn>
              </v-btn-toggle>
              <v-form class="login-form" @submit.prevent="login">
                <div class="login-field">
                  <label for="login-account">{{ loginType === 0 ? '手机号' : '员工号' }}</label>
                  <v-text-field v-if="loginType === 0" id="login-account" key="mobile" v-model="loginAccount" type="number" inputmode="numeric" autocomplete="username" placeholder="请输入手机号" prepend-inner-icon="mdi-cellphone" outlined hide-details color="#D9363E" />
                  <v-text-field v-if="loginType === 1" id="login-account" key="employee" v-model="loginAccount" type="number" inputmode="numeric" autocomplete="username" placeholder="请输入员工号" prepend-inner-icon="mdi-account-outline" outlined hide-details color="#D9363E" />
                </div>
                <div class="login-field"><label for="login-password">密码</label><v-text-field id="login-password" v-model="loginPassword" type="password" autocomplete="current-password" placeholder="请输入密码" prepend-inner-icon="mdi-lock-outline" outlined hide-details color="#D9363E" /></div>
                <div class="login-feedback" aria-live="polite"><p v-if="error.show" role="alert"><v-icon size="16">mdi-alert-circle-outline</v-icon><span>{{ error.msg }}</span></p></div>
                <v-btn type="submit" class="login-submit" color="#D9363E" dark block depressed height="50">登录<v-icon size="19">mdi-arrow-right</v-icon></v-btn>
              </v-form>
              <p class="login-account-help">请使用机构分配的账号登录<br><span>如需账号或重置密码，请联系机构管理员</span></p>
              <div class="login-welcome-note"><span></span>专注教学，把日常管理交给有课丫<span></span></div>
            </div>
          </section>
        </div>

        <footer class="login-footer"><span>Copyright © 2022 长沙永芸信息科技有限公司 All Rights Reserved.</span><span>ICP备案号：<a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">湘ICP备2022020124号-1</a></span></footer>
      </div>

      <v-dialog v-model="errorShow" width="440" persistent content-class="login-mobile-dialog">
        <v-card class="mobile-guide"><img class="mobile-guide-brand" src="../assets/login-brand.svg" alt="有课丫" width="126" height="34"><h2>手机上，也能轻松管理</h2><p>请使用电脑登录机构管理平台。<br>手机端可关注公众号「有课丫」登录。</p><v-img :src="qrcodeUrl" width="160" height="160" contain class="mobile-guide-qr" alt="有课丫公众号二维码" /><span class="mobile-guide-caption">关注公众号，进入手机端</span></v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
	import utils from "../config/utils"
	import storage from "../config/storage"
	import global from "../config/global"
	import md5 from "js-md5"
	import LoginScheduleIllustration from "../components/login/LoginScheduleIllustration.vue"


	export default {
        components: { LoginScheduleIllustration },
		data() {
			return {
				errorShow:false,
				loginType:0, // 0=手机号登录  1=员工号登录
				loginAccount:"",
				loginPassword:"",
				Loop:'', //  定时器
				qrcodeUrl:'https://photo.youkeya.cn/assets/icon/yky_gzh_qrcode.jpeg', // 后端返回的二维码图片路径
				error:{
					show:false,
					msg:""
				}
			}
		},
		created() {
			// document.title= "永芸信息";
			console.log(navigator.userAgent);
			//测试当前是哪个手机系统，可根据业务需要选择
			if(/Android|Windows Phone|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){
				this.errorShow =true;
				return;

			}else if(/iPad/i.test(navigator.userAgent)){
				console.log("pad端")
			}

			const token = storage.getToken();
			if (token && token.token) {
				this.$router.push("/");
			}



		},
		methods: {
			login() {

				console.log(this.loginType);

				if (!this.loginAccount){
					this.$noty.error('账号不能为空');
					return
				}

				const that = this;
				this.axios.post("/basic/employee/login", {
					loginType:this.loginType===0?'mobile':'empNo',
					loginAccount: this.loginAccount,
					loginPassword:  md5(this.loginPassword),
					loginPlatForm: "PcWeb",
				}).catch(function(e) {

				}).then(function(res) {
					console.log(res);
					if (res && res.data) {
						console.log(">>>>>>>>>>>>登录返回>>>>>>>>>>>>");
						console.log(res.data);
						console.log(">>>>>>>>>>>>登录返回>>>>>>>>>>>>");
						if (res.data["code"] === 200) {
							storage.setToken(res.data["data"]["token"]);
							global.employee = res.data["data"]["employee"];
							global.routeTree = res.data["data"]["menuTree"];

							// 获取七牛的token
							utils.getUploadImgToken();

							// 默认第一个校区为当前校区
							const shopList = global.employee.shopList.length ? global.employee.shopList : global.employee.renewalShopList || [];
							if (shopList.length > 0){
								// 设置当前的校区
								storage.setCurrentShop(shopList[0]);
							}


							let path = "/home/index"
							that.$router.push(path);

						} else {
							that.$noty.error("登录失败:"+res.data["message"]);
							that.error.show = true;
							that.error.msg = res.data["message"];
						}
					}
				});
			},
			touchEnd() {
			  //手指离开
			  clearTimeout(this.Loop);
			},
			touchStart() {
				//手指触摸
				clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
				this.Loop = setTimeout(() => {
					this.downloadIamge(this.qrcodeUrl, "youkeya_qrcode");
				}, 1000);
			},
			downloadIamge(imgsrc, name) {
				//创建a对象
				const link = document.createElement('a')
				link.setAttribute('download', name)

				// 根据图片链接创建图片对象
				const image = new Image()
				// 添加时间戳，防止浏览器缓存图片
				image.src = imgsrc + '?timestamp=' + new Date().getTime()
				// 设置 crossOrigin 属性，解决图片跨域报错
				image.setAttribute('crossOrigin', 'Anonymous')
				image.onload = () => {
					//图片加载好以后 把图片转base64 设置到a的href 触发点击开始下载
					link.href = this.imageToBase64(image)
				    link.click()
				}
			},
			imageToBase64(image) {
				// image对象转base64
			    let canvas = document.createElement('canvas');
			    let width = image.width;
			    let height = image.height;

			    canvas.width = width
			    canvas.height = height
			    let context = canvas.getContext('2d')
			    context.drawImage(image, 0, 0, width, height)
			    return canvas.toDataURL('image/png')
			}


		}
	}
</script>

<style scoped>
.login-page{background:#f5f7fa!important;color:#243244;font-family:"PingFang SC","Microsoft YaHei",sans-serif}
.login-shell{width:min(1280px,calc(100% - 112px));min-height:100vh;min-height:100dvh;margin:0 auto;display:flex;flex-direction:column}
.login-header{display:flex;align-items:center;justify-content:space-between;gap:20px;min-height:106px;padding:20px 0}
.login-page a{text-decoration:none}.login-brand{display:flex;align-items:center;gap:22px;flex-shrink:0}.login-brand img{display:block;width:143px;height:auto}.login-brand>span{border-left:1px solid #d8dee7;padding-left:22px;color:#687486;font-size:13px;letter-spacing:1px}.website-link{display:flex;align-items:center;gap:7px;color:#687486!important;font-size:13px}.website-link .v-icon{color:inherit}
.login-stage{display:grid;grid-template-columns:1.12fr 1fr;flex:1;min-height:650px;max-height:790px;overflow:hidden;border-radius:22px;background:#fff;border:1px solid #e9edf2;box-shadow:0 12px 55px -38px #31445945}
.login-story{position:relative;background:#fff4f2;padding:45px 48px 32px;display:flex;flex-direction:column;justify-content:center;overflow:hidden}
.story-copy{position:relative;z-index:1}.login-story .story-eyebrow{display:flex;align-items:center;gap:9px;color:#a65356;font-size:12px;letter-spacing:1px;margin:0 0 19px}.story-eyebrow>span{width:6px;height:6px;border-radius:50%;background:#d9363e}.login-story h1{font-size:40px;line-height:1.45;letter-spacing:1px;font-weight:650;color:#243244;margin:0}.login-story .story-description{font-size:14px;color:#75808e;line-height:1.95;margin:16px 0 0}
.story-capabilities{display:flex;flex-wrap:wrap;gap:25px;margin-top:26px;color:#8b7370;font-size:11px}.story-capabilities>span{display:flex;align-items:center;gap:7px}.story-capabilities .v-icon{color:#a18a86}
.login-form-panel{display:flex;align-items:center;justify-content:center;padding:50px 54px}.login-form-inner{width:100%;max-width:360px}.form-heading h2{font-size:30px;line-height:1.5;font-weight:650;letter-spacing:1px;margin:0}.form-heading p{font-size:14px;color:#7a8596;line-height:1.8;margin:10px 0 29px}
.login-methods{width:100%;display:flex!important;background:#f4f6f9!important;padding:5px;border-radius:9px!important;gap:4px;margin-bottom:28px}.login-page .login-methods>.v-btn{flex:1;min-width:0;height:42px!important;border:0!important;border-radius:6px!important;background:transparent!important;opacity:1!important;color:#7a8596!important;letter-spacing:0;font-size:13px}.login-methods>.v-btn .v-icon{margin-right:6px}.login-page .login-methods>.v-btn.v-btn--active{background:#fff!important;color:#c92d35!important;box-shadow:0 2px 6px #3341550d}.login-methods>.v-btn::before{opacity:0!important}
.login-field{margin-bottom:21px}.login-field>label{display:block;font-size:13px;color:#344156;margin-bottom:9px;font-weight:500}.login-field ::v-deep .v-input{font-size:14px}.login-field ::v-deep .v-input__slot{min-height:50px!important;padding:0 14px!important;background:#fff!important;border-radius:8px}.login-field ::v-deep fieldset{border:1px solid #dce2eb;color:#dce2eb!important}.login-field ::v-deep .v-input--is-focused fieldset{border:1.5px solid #d9363e!important}.login-field ::v-deep .v-input__prepend-inner{margin-top:14px!important;padding-right:10px}.login-field ::v-deep .v-input__prepend-inner .v-icon{font-size:20px;color:#9aa3b2}.login-field ::v-deep input{color:#243244;line-height:24px;max-height:34px;padding:10px 0}.login-field ::v-deep input::placeholder{color:#a1a9b5;opacity:1}.login-field ::v-deep input[type=number]{appearance:textfield;-moz-appearance:textfield}.login-field ::v-deep input::-webkit-inner-spin-button,.login-field ::v-deep input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}
.login-feedback{min-height:23px;margin-top:-7px;margin-bottom:10px}.login-feedback>p{display:flex;align-items:flex-start;gap:6px;color:#c92d35;font-size:12px;line-height:1.6;margin:0}.login-feedback .v-icon{color:#c92d35;margin-top:2px;flex-shrink:0}.login-submit{border-radius:8px;font-size:15px!important;font-weight:600;letter-spacing:3px!important}.login-submit .v-icon{position:absolute;right:2px;opacity:.85}.login-submit ::v-deep .v-btn__content{position:relative;width:100%}
.login-form-inner .login-account-help{font-size:12px;color:#778395;line-height:1.9;margin:21px 0 0;text-align:center}.login-account-help>span{font-size:11px;color:#939cab}.login-welcome-note{display:flex;align-items:center;justify-content:center;gap:12px;font-size:10px;white-space:nowrap;color:#a0a7b2;margin-top:40px}.login-welcome-note>span{display:block;width:24px;height:1px;background:#e7eaf0}
.login-footer{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px 22px;min-height:73px;padding:21px 0;color:#949dab;font-size:10px;line-height:1.8;text-align:center}.login-footer a{color:#7b8798!important}.login-page a:hover{color:#d9363e!important}.login-page a:focus-visible,.login-page button:focus-visible{outline:3px solid #446b9f;outline-offset:4px}
.mobile-guide{padding:34px 28px 30px!important;text-align:center;border-radius:15px!important;color:#243244}.mobile-guide-brand{display:block;margin:0 auto 24px}.mobile-guide h2{font-size:23px;font-weight:600;line-height:1.5}.mobile-guide p{font-size:13px;color:#748092;line-height:1.9;margin:15px 0 22px}.mobile-guide-qr{margin:0 auto}.mobile-guide-caption{display:block;font-size:12px;color:#8c97a6;margin-top:17px}
@media(min-width:1500px){.login-shell{padding-top:15px;padding-bottom:15px}.login-stage{flex:none;min-height:700px}.login-story{padding-inline:58px}.login-story h1{font-size:44px}}
@media(max-width:1150px){.login-shell{width:calc(100% - 64px)}.login-header{min-height:90px}.login-story{padding:36px 32px 28px}.login-story h1{font-size:34px;letter-spacing:0}.login-form-panel{padding:40px 35px}.login-stage{min-height:630px}.story-capabilities{gap:16px}}
@media(max-width:900px){.login-shell{width:min(640px,calc(100% - 48px))}.login-header{min-height:86px}.login-stage{display:block;min-height:0;max-height:none;flex:none}.login-story{padding:28px 34px}.login-story h1{font-size:28px}.login-story h1 br{display:none}.login-story .story-eyebrow{margin-bottom:10px;font-size:11px}.login-story .story-description{margin-top:10px;font-size:12px}.story-description br{display:none}.story-illustration,.story-capabilities{display:none}.login-form-panel{padding:32px 40px 38px}.login-form-inner{max-width:400px}.form-heading h2{font-size:26px}.form-heading p{margin:7px 0 23px}.login-welcome-note{margin-top:27px}.login-footer{margin-top:auto}.login-brand>span{font-size:12px;padding-left:16px}.login-brand{gap:16px}}
@media(max-width:480px){.login-shell{width:calc(100% - 32px)}.login-header{min-height:77px;padding:18px 2px}.login-brand img{width:119px}.login-brand>span{display:none}.website-link{font-size:11px}.login-stage{border-radius:16px}.login-story{padding:25px 24px}.login-story h1{font-size:26px;line-height:1.5}.login-story h1 br{display:block}.login-story .story-description{font-size:12px;max-width:235px}.login-form-panel{padding:28px 24px 30px}.form-heading h2{font-size:25px}.form-heading p{font-size:12px}.login-methods{margin-bottom:24px}.login-page .login-methods>.v-btn{font-size:12px}.login-methods>.v-btn .v-icon{font-size:16px!important}.login-field{margin-bottom:18px}.login-form-inner .login-account-help{font-size:11px}.login-account-help>span{font-size:10px}.login-welcome-note{font-size:9px;gap:7px}.login-welcome-note>span{width:14px}.login-footer{font-size:9px;padding:18px 4px;gap:4px;line-height:1.8}.mobile-guide{padding:28px 20px!important}.mobile-guide h2{font-size:21px}}
@media(prefers-reduced-motion:reduce){.login-page ::v-deep *{transition:none!important;animation:none!important}}
</style>
